





















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import AccessControlLayerPopup from '@/views/admin/AccessControlLayerPopup.vue';

interface ContractsEntryContracts {
  contractContents: string;
  changeReason: string;
}

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  GetPartnersInfoByNoRequest,
  PutPartnersInfoRequest,
  GetContractsRequest,
  PutContractsInfoRequest,
  GetContractsEntryContractsRequest,
  PostContractsEntryContractsRequest,
  PartnersInfoByNo,
  Contracts,
  GetContractsEntryContractsService,
  OriginalAddress,
  PartnerInfoRequestData,
  GetContractsContractNoRequest,
  GetContractsContractNoResponse,
  ContractsEditInfo,
  MasterAdminInfo
} from 'supporter';
const partnerModule = namespace('partner');
const contractsModule = namespace('contract');
//components
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import IpGuidePopup from '@/components/partner/IpGuidePopup.vue';
import MallsContractsGrid from '@/components/partner/MallsContractsGrid.vue';
//types
import country from '@/const/words/country';
import sellerTaxationType from '@/const/words/sellerTaxationType';
import bankList from '@/const/words/bank';
//utils
import { toI18n } from '@/utils/commonUtils';
import { ncpPopup } from '@/utils/ncp';
import { sanitize } from '@/utils/sanitizeHtml';
import emojiRegexp from '@/utils/emojiRegexp';
import TextInput from '@/pro/components/common/input/TextInput.vue';
import CsAdminInformation from './CsAdminInformation.vue';

@Component({
  components: {
    AccessControlLayerPopup,
    CompSelectBox,
    CompRadioButton,
    IpGuidePopup,
    MallsContractsGrid,
    TextInput,
    CsAdminInformation
  },
})
export default class PartnerEditForm extends Vue {
  @Prop({ required: true })
  readonly getPartnerRequestByNo!: GetPartnersInfoByNoRequest;
  @Prop({ required: true })
  readonly postPartnerRequestByNo!: PutPartnersInfoRequest;
  //
  @Prop({ required: true })
  readonly getContractsRequestByNo!: GetContractsRequest;
  @Prop({ required: true })
  readonly postContractsRequestByNo!: PutContractsInfoRequest;
  @Prop({ required: true })
  readonly getEntryContractsRequestByNo!: GetContractsEntryContractsRequest;
  @Prop({ required: true })
  readonly postEntryContractsRequestByNo!: PostContractsEntryContractsRequest;
  //
  @Prop({ required: true })
  readonly radioInitialOptions!: {
    [key: string]: {};
  };
  //getter
  @partnerModule.Getter('partnersInfoByNo')
  readonly partnersInfoByNo!: PartnersInfoByNo;
  @contractsModule.Getter('contractsInfo')
  readonly contractsInfo!: Contracts[];
  @contractsModule.Getter('contractsEntryContracts')
  readonly contractsEntryContracts!: GetContractsEntryContractsService[];
  @contractsModule.Getter('contractsContractNo')
  readonly contractsContractNo!: GetContractsContractNoResponse;
  //action
  @partnerModule.Action('fetchPartnersInfoByNo')
  private fetchPartnersInfoByNo!: (payload: GetPartnersInfoByNoRequest) => Promise<void>;
  @partnerModule.Action('putPartnersInfoByNo')
  private putPartnersInfoByNo!: (payload: PutPartnersInfoRequest) => Promise<void>;
  @contractsModule.Action('fetchContracts')
  private fetchContracts!: (payload: GetContractsRequest) => Promise<void>;
  @contractsModule.Action('fetchContractsEntryContracts')
  private fetchContractsEntryContracts!: (payload: GetContractsEntryContractsRequest) => Promise<void>;
  @contractsModule.Action('putContractsInfo')
  private putContractsInfo!: (payload: PutContractsInfoRequest) => Promise<void>;
  @contractsModule.Action('fetchContractsContractNo')
  readonly fetchContractsContractNo!: (payload: GetContractsContractNoRequest) => Promise<void>;

  private postPartnerRequest: PutPartnersInfoRequest = this.postPartnerRequestByNo;
  private postPartnerRequestData: PartnerInfoRequestData = this.postPartnerRequestByNo.data;
  private postContractsRequest: PutContractsInfoRequest = this.postContractsRequestByNo;
  private postContractsRequestData: (Partial<ContractsEditInfo> & { usesDefaultCommissionRate?: boolean })[] = this
    .postContractsRequestByNo.data.contracts;
  private postEntryContractsRequest: PostContractsEntryContractsRequest = this.postEntryContractsRequestByNo;
  private postEntryContractsRequestData: any = this.postEntryContractsRequestByNo.data;
  private entryContractsData = {
    contractNo: '',
    entryContracts: [],
  };
  private removeBankTargets = ['ANONYMOUS', 'MIZUHO', 'UFJ', 'SMBC', 'RESONA', 'KEB', 'MIRAE', 'SOLOMON_INVEST'];
  private banks = [].concat(
    bankList.filter(bank => {
      if (this.removeBankTargets.includes(bank.value)) {
        return;
      }
      return bank;
    }),
  );
  private countries = country;
  private sellerTaxationTypes = sellerTaxationType;

  private status = {
    WAITING: { key: 'WAITING', value: false },
    ACTIVE: { key: 'ACTIVE', value: false },
    INVESTIGATION: { key: 'INVESTIGATION', value: false },
  };
  private isDomestic = false;

  private CANCEL = 'CANCEL';
  private MOBILE = 'MOBILE';
  private DIRECT = 'DIRECT';
  private REDIRECT_URL = '/partner/list';

  private style = {
    show: { display: '' },
    hide: { display: 'none' },
    disable: 'disabled',
  };

  private flags: { [name: string]: boolean } = {
    directDisabled: false,
    accountDisabled: true,
    ipGuideDisabled: false,
    ipAccessControl: false,
  };
  private isValid: { [name: string]: boolean } = {
    faxNo: false,
    representPhoneNo: false,
    tradeBankAccount: false,
    masterPhoneNo: false,
    masterMobileNo: false,
    managerPhoneNo: false,
    privacyManagerPhoneNo: false,
    partnerName: false,
  };
  private separatedMobileNo = {
    firstNo: '',
    middleNo: '',
    lastNo: '',
  };
  private separatedEmail = {
    masterEmailId: '',
    masterEmailDomain: '',
    representEmailId: '',
    representEmailDomain: '',
    settlementManagerEmailId: '',
    settlementManagerEmailDomain: '',
    managerEmailId: '',
    managerEmailDomain: '',
  };

  // 운영자 IP 접속제한
  private useIpAccessControl = false;
  private permittedIpAddress = '';

  private bShowGuide: boolean = false;

  @Watch('useIpAccessControl')
  private changedUseIpAccessControl() {
    if (!this.useIpAccessControl) {
      this.permittedIpAddress = '';
      this.partnersInfoByNo.masterAdmin.permittedIpAddresses = [];
      this.postPartnerRequestData.masterAdmin.permittedIpAddresses = [];
    }
  }

  private getFilteredMasterAdmin(adminInfo): MasterAdminInfo {
    const masterAdmin = Object.assign({}, adminInfo);
    Object.keys(masterAdmin).forEach(key => {
      if (key === 'permittedIpAddresses' || key === 'externalAccessEnabled') return;
      masterAdmin[key] = masterAdmin[key] || '-';
    });
    return masterAdmin;
  }

  private bindPostPartnerRequestData() {
    this.isDomestic = this.partnersInfoByNo.countryCode === 'KR';
    this.postPartnerRequestData.officeAddress.zipCode = this.partnersInfoByNo.office.zipCode;
    this.postPartnerRequestData.officeAddress.streetAddress1 = this.partnersInfoByNo.office.address;
    this.postPartnerRequestData.officeAddress.streetAddress2 = this.partnersInfoByNo.office.detailAddress;
    this.postPartnerRequestData.officeAddress.jibunAddress1 = this.partnersInfoByNo.office.jibun;
    this.postPartnerRequestData.officeAddress.jibunAddress2 = this.partnersInfoByNo.office.jibunDetail;
    this.postPartnerRequestData.officeAddress.city = this.partnersInfoByNo.office.city;
    this.postPartnerRequestData.officeAddress.stateOrRegion = this.partnersInfoByNo.office.stateOrRegion;

    this.postPartnerRequestData.partnerName = this.partnersInfoByNo.partnerName;
    this.postPartnerRequestData.companyName = this.partnersInfoByNo.companyName;
    this.postPartnerRequestData.sellerTaxationType = this.isDomestic ? this.partnersInfoByNo.sellerTaxationType : null;// 과세
    this.postPartnerRequestData.faxNo = this.isDomestic ? this.partnersInfoByNo.faxNo : null; //팩스번호
    //this.partnersInfoByNo.representative.phoneNo
    this.postPartnerRequestData.representative.representPhoneNo = this.partnersInfoByNo.representative.phoneNo;
    this.postPartnerRequestData.representative.representEmail = this.partnersInfoByNo.representative.email;
    this.postPartnerRequestData.representative.representName = this.partnersInfoByNo.representative.name;
    this.postPartnerRequestData.business.onlineMarketingBusinessDeclarationNo = this.partnersInfoByNo.business.onlineMarketingDeclarationNo;
    this.postPartnerRequestData.business.businessType = this.isDomestic ? this.partnersInfoByNo.business.type : null; //업종
    this.postPartnerRequestData.business.businessRegistrationNo = this.partnersInfoByNo.business.registrationNo;
    this.postPartnerRequestData.business.businessCondition = this.isDomestic ? this.partnersInfoByNo.business.condition : null; //업태

    this.postPartnerRequestData.settlement.settlementManagerPhoneNo = this.partnersInfoByNo.settlementManager.phoneNo;
    this.postPartnerRequestData.settlement.settlementManagerName = this.partnersInfoByNo.settlementManager.name;
    this.postPartnerRequestData.settlement.settlementManagerEmail = this.partnersInfoByNo.settlementManager.email;
    this.postPartnerRequestData.bank.tradeBankName = this.partnersInfoByNo.tradeBank.bankName;
    this.postPartnerRequestData.bank.tradeBankDepositorName = this.partnersInfoByNo.tradeBank.depositorName;
    this.postPartnerRequestData.bank.tradeBankAccount = this.partnersInfoByNo.tradeBank.account;
    this.postPartnerRequestData.bank.tradeBank = !this.partnersInfoByNo.tradeBank.bank
      ? this.DIRECT
      : this.partnersInfoByNo.tradeBank.bank;
    this.postPartnerRequestData.permittedIpAddress = this.partnersInfoByNo.permittedIpAddress;

    this.postPartnerRequestData.masterAdmin = {
      masterJobPositionName: this.partnersInfoByNo.masterAdmin.jobPositionName,
      masterDepartmentName: this.partnersInfoByNo.masterAdmin.departmentName ,
      masterJobName: this.partnersInfoByNo.masterAdmin.jobDutyName,
      masterPhoneNo: this.partnersInfoByNo.masterAdmin.phone,
      externalAccess: this.partnersInfoByNo.masterAdmin.externalAccessEnabled,
      masterMobileNo: this.partnersInfoByNo.masterAdmin.mobile,
      permittedIpAddresses: this.partnersInfoByNo.masterAdmin.permittedIpAddresses,
    };
    this.postPartnerRequestData.privacyManager.privacyManagerPhoneNo = this.partnersInfoByNo.privacyManager.phoneNo;
    this.postPartnerRequestData.privacyManager.privacyManagerName = this.partnersInfoByNo.privacyManager.name;

    this.postPartnerRequestData.manager.managerPhoneNo = this.partnersInfoByNo.manager.phoneNo;
    this.postPartnerRequestData.manager.managerName = this.partnersInfoByNo.manager.name;
    this.postPartnerRequestData.manager.managerJobPosition = this.partnersInfoByNo.manager.jobPosition;
    this.postPartnerRequestData.manager.managerJobDuty = this.partnersInfoByNo.manager.jobDuty;
    this.postPartnerRequestData.manager.managerEmail = this.partnersInfoByNo.manager.email;
    this.postPartnerRequestData.manager.managerDepartment = this.partnersInfoByNo.manager.department;

    this.postPartnerRequestData.sampleUrl = this.partnersInfoByNo.sampleUrl;

    this.postPartnerRequestData.internationalCode.bsbCode = this.partnersInfoByNo.internationalCode.bsbCode;
    this.postPartnerRequestData.internationalCode.swiftCode = this.partnersInfoByNo.internationalCode.swiftCode;
    this.postPartnerRequestData.internationalCode.abaRoutingNo = this.partnersInfoByNo.internationalCode.abaRoutingNo;
    this.postPartnerRequestData.internationalCode.ibanCode = this.partnersInfoByNo.internationalCode.ibanCode;

    // 운영자 IP 접속제한
    this.useIpAccessControl = this.partnersInfoByNo?.masterAdmin?.permittedIpAddresses?.length > 0;
    this.permittedIpAddress = this.partnersInfoByNo?.masterAdmin?.permittedIpAddresses?.join('\n') || '';
    this.postPartnerRequestData.csManager = {
      csManagerName: this.partnersInfoByNo.csManager.name,
      csManagerPhoneNo: this.partnersInfoByNo.csManager.phoneNo,
      csManagerEmail: this.partnersInfoByNo.csManager.email,
      csManagerOperationInfo: this.partnersInfoByNo.csManager.operationInfo,
    }

    this.postPartnerRequestData.dependencyYn = this.partnersInfoByNo.dependencyYn

    this.setParamsToGetEntryContractsData();
    this.bindSplitData();
  }

  private bindSplitData() {
    this.toSplit('represent', this.partnersInfoByNo.representative.email);
    this.toSplit('settlementManager', this.partnersInfoByNo.settlementManager.email);
    this.toSplit('master', this.partnersInfoByNo.masterAdmin.email);
    this.toSplit('manager', this.partnersInfoByNo.manager.email);
    this.toSplit(this.MOBILE, this.partnersInfoByNo.masterAdmin.mobile);
  }
  private setParamsToGetEntryContractsData() {
    this.contractsInfo.forEach(contract => {
      this.getEntryContractsRequestByNo.pathParams = {
        ...this.getEntryContractsRequestByNo,
        contractNo: contract.contractNo.toString(),
      };
    });
  }
  private bindPostContractsRequestData() {
    this.contractsInfo.forEach(info => {
      this.postContractsRequestData.push({
        commissionRate: info.pureCommissionRate,
        contractNo: info.contractNo,
        promotionAgreed: info.promotionAgreed,
        merchandiserNo: info.merchandiserNo,
        usesDefaultCommissionRate: info.usesDefaultCommissionRate,
      });
      this.fetchEntryContracts(`${info.contractNo}`);
    });
    this.postContractsRequest.data.contracts.shift();
  }
  // 입점계약 동의 여부 조회
  private entryContracts = [];
  private async fetchEntryContracts(contractNo: string) {
    await this.fetchContractsContractNo({
      pathParams: {
        contractNo,
      },
    });
    const contractsContractNo = this.contractsContractNo as any;
    this.entryContracts.push({
      contractNo,
      agreeWithStandingPointContract:
        contractsContractNo.entryContracts.length < 1 ? null : contractsContractNo.entryContracts[0].agreed,
    });
  }
  private setUpdatedContacts() {
    this.postPartnerRequestData.representative.representEmail = this.toRestore([
      this.separatedEmail.representEmailId,
      this.separatedEmail.representEmailDomain,
    ]);
    this.postPartnerRequestData.manager.managerEmail = this.toRestore([
      this.separatedEmail.managerEmailId,
      this.separatedEmail.managerEmailDomain,
    ]);
    this.postPartnerRequestData.settlement.settlementManagerEmail = this.toRestore([
      this.separatedEmail.settlementManagerEmailId,
      this.separatedEmail.settlementManagerEmailDomain,
    ]);
  }
  private async created() {
    await this.setPartnerData();
    await this.setMallsContractData();
  }
  private async setPartnerData() {
    await this.fetchPartnersInfoByNo(this.getPartnerRequestByNo);
    this.setPartnerStatus();
    this.bindPostPartnerRequestData();
    this.flags.directDisabled = !this.partnersInfoByNo.tradeBank.bank;
    this.partnersInfoByNo.masterAdmin = this.getFilteredMasterAdmin(this.partnersInfoByNo.masterAdmin);
  }
  private async setMallsContractData() {
    await this.fetchContracts(this.getContractsRequestByNo);
    await this.bindPostContractsRequestData();
    this.bindGridElementEvents();
  }
  private async reloadContracts() {
    await this.fetchContracts(this.getContractsRequestByNo);
  }

  private setPartnerStatus() {
    this.status[this.partnersInfoByNo.partnerStatus].value = true;
  }
  //계좌정보 수정
  private checkTradeBankName() {
    if (this.postPartnerRequestData.bank.tradeBank !== this.DIRECT) {
      this.flags.directDisabled = false;
      return;
    }
    this.resetAccountInfo();
  }
  private resetAccountInfo() {
    this.postPartnerRequestData.bank.tradeBankName = '';
    this.postPartnerRequestData.bank.tradeBankAccount = '';
    this.postPartnerRequestData.bank.tradeBankDepositorName = '';
    this.flags.directDisabled = true;
  }
  private canEditAccountInfo() {
    this.flags.accountDisabled = false;
  }
  // for grid
  private $useDefaultCommissionRateEls: NodeList = null;
  private $isAgreePromotionEls: NodeList = null;
  private $approvalBtns: NodeList = null;
  private $reSendEmailBtns: NodeList = null;
  private $commissionRateEls: NodeList = null;
  private $contractSuspendEls: NodeList = null;
  private $contractUnsuspendEls: NodeList = null;

  private bindGridElementEvents() {
    this.$useDefaultCommissionRateEls = document.querySelectorAll('.usesDefaultCommissionRate');
    this.$isAgreePromotionEls = document.querySelectorAll('.promotionAgreed');
    this.$approvalBtns = document.querySelectorAll('.approvalBtns');
    this.$reSendEmailBtns = document.querySelectorAll('.grid_btn_resend');
    this.$commissionRateEls = document.querySelectorAll('.commissionRate');
    this.$contractSuspendEls = document.querySelectorAll('.grid_btn_suspend');
    this.$contractUnsuspendEls = document.querySelectorAll('.grid_btn_unsuspend');

    this.bindEvents(
      this.$useDefaultCommissionRateEls,
      this.bindEventListener.bind(this),
      'change',
      this.toggleInputForCommissionRate.bind(this),
    );
    this.bindEvents(this.$isAgreePromotionEls, this.bindEventListener.bind(this), 'change', null);
    this.bindEvents(this.$commissionRateEls, this.bindEventListener.bind(this), 'keyup', null);
    this.bindEvents(this.$approvalBtns, this.bindEventListener.bind(this), 'click', this.approvalHandler.bind(this));
    this.bindEvents(
      this.$reSendEmailBtns,
      this.bindEventListener.bind(this),
      'click',
      this.resendEmailEvent.bind(this),
    );
    this.bindEvents(this.$contractSuspendEls, this.bindEventListener.bind(this), 'click', this.contractSuspendEvent.bind(this));
    this.bindEvents(this.$contractUnsuspendEls, this.bindEventListener.bind(this), 'click', this.contractUnsuspendEvent.bind(this));
  }
  private bindEvents(elements, fn, name, cb) {
    Array.from(elements).forEach(el => {
      fn(el, name, cb);
    });
  }

  private bindEventListener(element: HTMLElement, eventName: string, fn: Function) {
    element.addEventListener(eventName, event => {
      const target: HTMLElement = event.target as any;
      this.postContractsRequestData.forEach(info => {
        if (info.contractNo === Number(target.dataset.contractNo)) {
          const $currentInputElement = target as HTMLInputElement;
          info[$currentInputElement.className] = $currentInputElement.value && JSON.parse($currentInputElement.value);
          fn && fn(event, info);
        }
      });
    });
  }
  private toggleInputForCommissionRate(event, { contractNo }) {
    const { value } = event.target;
    this.$commissionRateEls.forEach(commissionRate => {
      const $currentCommissionRate = commissionRate as HTMLInputElement;
      if (contractNo === Number($currentCommissionRate.dataset.contractNo)) {
        JSON.parse(value)
          ? $currentCommissionRate.removeAttribute(this.style.disable)
          : $currentCommissionRate.setAttribute(this.style.disable, '');
      }
    });
  }
  // 검토완료/반려 클릭 시 이벤트 핸들러
  private approvalHandler(event) {
    const { name, dataset } = event.target;
    name === 'approval' ? this.approvalEvent(dataset.contractNo) : this.disapprovalEvent(dataset.contractNo);
  }
  // 검토완료
  private async approvalEvent(contractNo) {
    if (!confirm(this.toI18n('PARTNER_EDIT_APPROVAL_NOTICE_MSG'))) return;
    //검토완료 알림메일 전송하기
    this.$api.putContractsContractNoApprovalRequest({ params: { contractNo } });
    await this.toUpdateMallContract(this.status.ACTIVE.key);
    alert(this.toI18n('PARTNER_EDIT_APPROVAL_MSG'));
  }
  // 반려
  private async disapprovalEvent(contractNo) {
    if (!confirm(this.toI18n('PARTNER_EDIT_DISAPPROVAL_NOTICE_MSG'))) return;
    //반려 알림메일 전송하기
    this.$api.putContractsContractNoDisapprovalRequest({ params: { contractNo } });
    await this.toUpdateMallContract(this.status.WAITING.key);
    alert(this.toI18n('PARTNER_EDIT_DISAPPROVAL_MSG'));
  }
  private resendEmailEvent(event) {
    const { target } = event;
    this.resendEmailHandler(target.dataset && Number(target.dataset.contractNo));
    alert(this.toI18n('PARTNER_EDIT_NOTICE_RESEND_EMAIL'));
  }

  private contractSuspendEvent({target}) {
    if (confirm(this.$t('PARTNER_EDIT_CONFIRM_SUSPEND').toString())) {
      const { dataset } = target;
      this.$api.putContractsContractNo({pathParams: {contractNo: dataset.contractNo}, data: {status: 'SUSPEND'}}).then(() => {
        alert(this.$t('PARTNER_EDIT_ALERT_SUSPEND_COMPLETE'));
        location.reload();
      });
    }
  }

  private contractUnsuspendEvent({target}) {
    if (confirm(this.$t('PARTNER_EDIT_CONFIRM_UNSUSPEND').toString())) {
      const { dataset } = target;
      this.$api.putContractsContractNo({pathParams: {contractNo: dataset.contractNo}, data: {status: 'UNSUSPEND'}}).then(() => {
        alert(this.$t('PARTNER_EDIT_ALERT_UNSUSPEND_COMPLETE'));
        location.reload();
      });
    }
  }

  private resendEmailHandler(contractNo?: number) {
    const request = {
      pathParams: {
        partnerNo: this.partnersInfoByNo.partnerNo.toString(),
      },
      data: {
        contractNo,
      },
    };
    this.$api.postPartnersPartnerNoResendEmail(request);
  }
  private async toUpdateMallContract(status) {
    if (!this.postContractsRequestData.length) return;
    this.updatePartnerStatus(status);
    await this.putContractsInfo(this.postContractsRequest);
    // 거래쇼핑몰 정보 업데이트 후 재랜더링
    await this.setMallsContractData();
  }
  private updatePartnerStatus(status) {
    for (const target in this.status) {
      this.status[target].value = this.status[target].key === status;
    }
  }
  // 변경사항 저장
  private async onSubmit() {
    // 파트너 노출여부 설정
    if (this.partnersInfoByNo.dependencyYn !== this.postPartnerRequestData.dependencyYn && !confirm(`해당 파트너사의 노출 설정을 ‘${this.postPartnerRequestData.dependencyYn? '노출 안 함' : '노출함'}’으로 변경하시겠습니까?\n${this.postPartnerRequestData.dependencyYn ? '노출 안 함 으로 설정 시 파트너 조회결과에 노출되지 않습니다' : '변경 시 파트너 검색/등록 시 조회결과에 노출됩니다.'}`)) {
      return;
    }

    if (!confirm(this.toI18n('PARTNER_EDIT_CONFIRM_SAVE'))) return;
    // to update partner info
    this.setUpdatedContacts();
    this.setUpdatedPartnersContents();
    this.setPermittedIpAddresses();
    if (this.alertErrorMsg(this.checkEmptyValue())) return;
    if (!this.isValidCheck()) return;

    try {
      // 파트너명 XSS처리: postPartnerRequest 와 postPartnerRequestData 가 별도 코드이기때문에 추후 변경필요함.
      this.postPartnerRequest.data.partnerName = sanitize(this.postPartnerRequestData.partnerName); // 일단 하드코딩
      await this.putPartnersInfoByNo(this.postPartnerRequest);

      // to update malls contracts info
      if (!this.postContractsRequestData.length) return;

      await this.putContractsInfo(this.postContractsRequest);

      alert(this.toI18n('PARTNER_EDIT_NOTICE_SAVED'));
      this.goToPartnerListPage();
    } catch (error) {
      const isInvalidIP = error.data?.errors?.some(({ reason }) => reason.includes('Invalid IP'));

      if (isInvalidIP) {
        alert(this.$t('PARTNER_EDIT_PLZ_CHECK_PERMITTED_IP_ADDRESS'));
      }
    }
  }
  private goToPartnerListPage() {
    this.$router.push(this.REDIRECT_URL);
  }

  private isValidCheck() {
    const gridData = this.postContractsRequestData;
    const { csManagerPhoneNo: phoneNo, csManagerEmail: email } = this.postPartnerRequestData.csManager;

    for (let i = 0; i < gridData.length; i++) {
      if (gridData[i].usesDefaultCommissionRate && !gridData[i].commissionRate.toString()) {
        alert(this.toI18n('PARTNER_EDIT_ALERT_NO_COMMISSION_RATE'));
        return false;
      }
    }

    if (phoneNo.length && (phoneNo.match(/[\d-]/g)?.join('') !== phoneNo || phoneNo.length < 8)) {
      alert(this.$t('PARTNER_EDIT_CS_PHONE_NO_ALERT'));
      return false;
    }

    if (email.replace(/[\s‘”<>`(),:;\\[\]]/g, '') !== email) {
      alert(this.$t('PARTNER_EDIT_CS_EMAIL_ALERT'));
      return false;
    }

    return true;
  }
  // 파트너 폼 데이터 바인딩
  private setUpdatedPartnersContents() {
    const { csManagerEmail } = this.postPartnerRequestData.csManager;

    this.postPartnerRequest = {
      ...this.postPartnerRequest,
      data: {
        ...this.postPartnerRequestData,
        bank: {
          ...this.postPartnerRequestData.bank,
          tradeBank: this.postPartnerRequestData.bank.tradeBank === this.DIRECT ? null : this.postPartnerRequestData.bank.tradeBank,
          tradeBankName: this.postPartnerRequestData.bank.tradeBank === this.DIRECT ? this.postPartnerRequestData.bank.tradeBankName : null,
        },
        representative: {
          representEmail: this.postPartnerRequestData.representative.representEmail,
          representativeName: this.postPartnerRequestData.representative.representName,
          representPhoneNo: this.postPartnerRequestData.representative.representPhoneNo,
        },
        csManager: {
          ...this.postPartnerRequestData.csManager,
          csManagerEmail: csManagerEmail.split('@').some((item) => !item) ? '' : csManagerEmail
        }
      },
    };
  }

  // 운영자 접속가능 IP 등록 문자열을 request 형식에 맞춰 변환
  private setPermittedIpAddresses() {
    if (this.useIpAccessControl) {
      this.postPartnerRequestData.masterAdmin.permittedIpAddresses = this.permittedIpAddress
        .split('\n')
        .map(v => v.trim())
        .filter(Boolean);
    } else {
      this.postPartnerRequestData.masterAdmin.permittedIpAddresses = [];
    }
  }
  // 취소, 닫기
  private close(type) {
    switch (type) {
      case this.CANCEL:
        if (!confirm(this.toI18n('PARTNER_EDIT_CANCEL_NOTICE_MSG'))) return;
      default: {
        this.$router.push(this.REDIRECT_URL);
      }
    }
  }
  private deletePartner() {
    if (!confirm(this.toI18n('PARTNER_EDIT_CONFIRM_DELETE_PARTNER'))) return;
    this.$api.deletePartnersPartnerNo({
      pathParams: {
        partnerNo: this.partnersInfoByNo.partnerNo.toString(),
      },
    });
    this.$router.push(this.REDIRECT_URL);
  }
  // 화면 출력에 맞게 정보를 변환
  private toSplit(type: string, value: string) {
    if (type === this.MOBILE && this.isDomestic) {
      const noHyphenMobileNo = value.replace(/\-/g, '');
      this.separatedMobileNo.firstNo = noHyphenMobileNo.substring(0, 3);
      this.separatedMobileNo.middleNo = noHyphenMobileNo.substring(3, noHyphenMobileNo.length - 4);
      this.separatedMobileNo.lastNo = noHyphenMobileNo.substring(noHyphenMobileNo.length - 4, noHyphenMobileNo.length);
      return;
    }
    const id = 'EmailId';
    const domain = 'EmailDomain';
    const email = value.split('@');
    this.separatedEmail = {
      ...this.separatedEmail,
      [type + id]: email[0],
      [type + domain]: email[1],
    };
  }
  // api 호출 데이터 형식에 맞게 변환
  private numberWithHyphen(value: string): string {
    this.toSplit(this.MOBILE, value);
    let number = '';
    for (const no in this.separatedMobileNo) {
      number += `${this.separatedMobileNo[no]}-`;
    }
    return number.substring(0, number.length - 1);
  }
  private toRestore(value: string[], type?: string): string {
    if (type === this.MOBILE) {
      return `${value[0]}-${value[1]}-${value[2]}`;
      // return `010-${value[0]}-${value[1]}`
    }
    // undefined 로 변형되는 경우가 있어 예외처리함
    if (!value[0].length) return;
    return `${value[0]}@${value[1]}`;
  }
  //true - show , false - hide
  private canShowAndHide(value) {
    return value ? this.style.show : this.style.hide;
  }
  // 문자 변환
  private toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  //우편번호 찾기 팝업
  private addressPopupCallback(address: OriginalAddress): void {
    (window as any).addressCallback = undefined;
    this.postPartnerRequestData.officeAddress.zipCode = address.zipCode;
    this.postPartnerRequestData.officeAddress.streetAddress1 = address.roadAddress;
    this.postPartnerRequestData.officeAddress.streetAddress2 = address.roadAddressExtra;
    this.postPartnerRequestData.officeAddress.jibunAddress1 = address.jibunAddress;
    this.postPartnerRequestData.officeAddress.jibunAddress2 = '';
  }
  private openAddressPopup(): void {
    (window as any).addressCallback = this.addressPopupCallback;
    ncpPopup('/address/search/popup?dataCallback=addressCallback', '_blank', 550, 880);
  }
  //ip 가이드 팝업
  private ipGuidePopupToggle() {
    this.flags.ipGuideDisabled = !this.flags.ipGuideDisabled;
  }
  // 이모지 검사
  private removeEmoji(event: { target: HTMLInputElement }) {
    const { name, value } = event.target;
    if (emojiRegexp.test(value)) {
      this.bindInputData(name, value.replace(emojiRegexp, ''));
    }
  }
  // 입력값 유효성 검사
  private checkInputType(event: { target: HTMLInputElement }) {
    const { name, value } = event.target;

    let isChecked = false;
    isChecked =
      name === 'tradeBankAccount'
        ? this.isValidPattern(event, new RegExp(/^[0-9]+$/))
        : this.isValidPattern(event, new RegExp(/^[0-9-]+$/));

    if (!isChecked) return this.errorHandler(name, value);

    this.bindInputData(name, value);
    this.isValid[name] = false;
  }
  private isValidPattern({ target: { value } }, pattern): boolean {
    return pattern.test(value);
  }
  private errorHandler(name, value) {
    this.isValid[name] = true;
    this.bindInputData(name, value.substring(0, value.length - 1));
  }
  private bindInputData(name, value) {
    switch (name) {
      case 'faxNo':
        this.postPartnerRequestData.faxNo = value;
        break;
      case 'representPhoneNo':
        this.postPartnerRequestData.representative.representPhoneNo = value;
        break;
      case 'settlementManagerPhoneNo':
        this.postPartnerRequestData.settlement.settlementManagerPhoneNo = value;
        break;
      case 'managerPhoneNo':
        this.postPartnerRequestData.manager.managerPhoneNo = value;
        break;
      case 'tradeBankAccount':
        this.postPartnerRequestData.bank.tradeBankAccount = value;
        break;
      case 'privacyManagerPhoneNo':
        this.postPartnerRequestData.privacyManager.privacyManagerPhoneNo = value;
        break;
      case 'partnerName':
        this.postPartnerRequestData.partnerName = value;
    }
  }

  // 에러처리
  private alertErrorMsg(err): boolean {
    if (!err) return false;
    const { title, currentEl } = err;
    const notice = this.hasKoreanFinalConsonant(this.toI18n(title))
      ? 'PARTNER_EDIT_INPUT_ERROR_MSG_WITH_CONSONANT'
      : 'PARTNER_EDIT_INPUT_ERROR_MSG_WITHOUT_CONSONANT';

    alert(`${this.toI18n(title)}${this.toI18n(notice)}`);
    (this.$refs[currentEl] as HTMLElement).focus();
    return true;
  }
  // 받침 유무 확인 true: 받침있음, false: 받침없음
  private hasKoreanFinalConsonant(word): boolean {
    if (typeof word !== 'string') return;
    const startKoreanUniCode = 44032;
    const endKoreanUniCode = 55203;
    const finalConsonants = 28;
    const lastLetter = word[word.length - 1];
    const targetUniCode = lastLetter.charCodeAt(0);
    // 한글이 아닌 경우
    if (targetUniCode < startKoreanUniCode || targetUniCode > endKoreanUniCode) return null;
    return (targetUniCode - startKoreanUniCode) % finalConsonants !== 0;
  }
  private checkEmptyValue() {
    const refs = this.$refs;
    // this.toConvertErrorMsg('PARTNER_CONTRACT_ADDRESS', 'officeZipCode')
    if (!(refs.officeZipCode as HTMLInputElement).value)
      return { title: 'PARTNER_CONTRACT_ADDRESS', currentEl: 'officeZipCode' };
    if (!(refs.companyName as HTMLInputElement).value)
      return { title: 'PARTNER_COMPANY_NAME', currentEl: 'companyName' };
    if (!(refs.partnerName as HTMLInputElement).value)
      return { title: 'PARTNER_PARTNER_NAME', currentEl: 'partnerName' };
    if (!(refs.businessRegistrationNo as HTMLInputElement).value)
      return { title: 'PARTNER_REGISTRATION_NO', currentEl: 'businessRegistrationNo' };
    if (!(refs.representativeName as HTMLInputElement).value)
      return { title: 'PARTNER_REPRESENTATIVE_NAME', currentEl: 'representativeName' };
    if (this.isDomestic && !(refs.businessType as HTMLInputElement).value)
      return { title: 'PARTNER_BUSINESS_TYPE', currentEl: 'businessType' };//업종
    if (!(refs.representPhoneNo as HTMLInputElement).value)
      return { title: 'PARTNER_REPRESENT_PHONE_NO', currentEl: 'representPhoneNo' };
    if (!(refs.representEmailId as HTMLInputElement).value)
      return { title: 'PARTNER_CONTRACT_REPRESENT_EMAIL', currentEl: 'representEmailId' };
    if (!(refs.representEmailDomain as HTMLInputElement).value)
      return { title: 'PARTNER_CONTRACT_REPRESENT_EMAIL', currentEl: 'representEmailDomain' };
    if (!(refs.representativeName as HTMLInputElement).value)
      return { title: 'PARTNER_REPRESENTATIVE_NAME', currentEl: 'representativeName' };
    if (!(refs.settlementManagerName as HTMLInputElement).value)
      return { title: 'PARTNER_CONTRACT_SETTLEMENT_NAME', currentEl: 'settlementManagerName' };
    if (!(refs.settlementManagerPhoneNo as HTMLInputElement).value)
      return { title: 'PARTNER_CONTRACT_SETTLEMENT_PHONE_NO', currentEl: 'settlementManagerPhoneNo' };
    if (!(refs.settlementManagerEmailId as HTMLInputElement).value)
      return { title: 'PARTNER_CONTRACT_ADMIN_EMAIL', currentEl: 'settlementManagerEmailId' };
    if (!(refs.settlementManagerEmailDomain as HTMLInputElement).value)
      return { title: 'PARTNER_CONTRACT_ADMIN_EMAIL', currentEl: 'settlementManagerEmailDomain' };
    if (!(refs.tradeBank as CompSelectBox).selectedValue)
      return { title: 'PARTNER_CONTRACT_TRADE_BANK', currentEl: 'tradeBank' };
    if (((refs.tradeBank as CompSelectBox).selectedValue === this.DIRECT) && !(refs.tradeBankName as HTMLInputElement).value)
      return { title: 'PARTNER_CONTRACT_TRADE_BANK', currentEl: 'tradeBankName' };
    if (!(refs.tradeBankAccount as HTMLInputElement).value)
      return { title: 'PARTNER_CONTRACT_TRADE_BANK', currentEl: 'tradeBankAccount' };
    if (!(refs.tradeBankDepositorName as HTMLInputElement).value)
      return { title: 'PARTNER_CONTRACT_TRADE_BANK', currentEl: 'tradeBankDepositorName' };
    if (!this.flags.accountDisabled) {
      if (!(refs.tradeBankName as HTMLInputElement).value && !(refs.tradeBank as CompSelectBox).selectedValue)
        return { title: 'PARTNER_CONTRACT_TRADE_BANK', currentEl: 'tradeBankName' };
    }
    if (this.useIpAccessControl && !(refs.ipAddressRef as HTMLTextAreaElement).value.trim())
      return { title: 'ADMIN_EDIT_REGISTRATION_ACCESSIBLE_IP', currentEl: 'ipAddressRef' };
  }
  private beforeDestroy() {
    this.removeEvents(this.$useDefaultCommissionRateEls, 'change', this.toggleInputForCommissionRate.bind(this));
    this.removeEvents(this.$isAgreePromotionEls, 'change', null);
    this.removeEvents(this.$commissionRateEls, 'keyup', null);
    this.removeEvents(this.$approvalBtns, 'click', this.approvalHandler.bind(this));
    this.removeEvents(this.$reSendEmailBtns, 'click', this.resendEmailEvent.bind(this));
    this.removeEvents(this.$contractSuspendEls, 'click', this.contractSuspendEvent.bind(this));
    this.removeEvents(this.$contractUnsuspendEls, 'click', this.contractUnsuspendEvent.bind(this));
  }
  private removeEvents(els: NodeList, eventType: string, fn: Function) {
    els.forEach(el => el.removeEventListener(eventType, ()=>fn));
  }

  private showGuide (): void {
    this.bShowGuide = true;
  }
  private hideGuide(): void {
    this.bShowGuide = false;
  }

}
